class BasicStrategy {
  async start(initalData) {
    await this.$vm.startFlow(initalData)
  }

  async finally() {
    // 传递扫码识别后的查询到的商品明细数据
    this.$vm.$emit('on-change', { infos: this.$vm.goodsInfo })
    // 确认提交
    await this.$vm.onScanConfirm()

    // 正确识别后清除扫码输入框
    console.log('是否正确识码: ', this.$vm.scanResult.success)
    if (this.$vm.scanResult.success) {
      console.log('正确识别后清除扫码输入框')
      this.$vm.clearInput()
    }
  }
}

export default BasicStrategy
